// libs
require('jquery');
require('bootstrap');
require('bootstrap4-toggle');
require('./inter/core/doubletap');

/*! inter-theme-web */
require('./inter/navigation/mmenu');
require('./inter/navigation/desktop');
require('./inter/core/footer.js');

/*! inter-neo */
require('./neo/neo.js');

/*! expose jquery */
window.$ = window.jQuery = require("jquery")
